import { Users } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/** Which lookalike an ad set targets and whether its lead quality is verified. Nothing for other ad sets. */
const LookalikeNote = ({ note }) => {
    if (!note) return null

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span role="img" aria-label={note} className="tw:shrink-0" data-testid="lookalike-note">
                    <Users size={16} className="tw:text-gray-200" />
                </span>
            </TooltipTrigger>
            <TooltipContent className="tw:max-w-80">
                <span>{note}</span>
            </TooltipContent>
        </Tooltip>
    )
}

export default LookalikeNote
